// import 'babel-polyfill';
// import 'promise-polyfill/src/polyfill';
// import 'whatwg-fetch';

import ReactDOM from 'react-dom';
import App from './app.js';

ReactDOM.render(App, document.getElementById('root'));



// WEBPACK FOOTER //
// ./entry.js